var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          attrs: { center: "", visible: _vm.dialogVisible, width: "50%" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "title" }, [_vm._v("速度挣钱哦~~")]),
          _c("div", { staticStyle: { padding: "0 0.24rem" } }, [
            _c(
              "p",
              {
                staticClass: "p1",
                staticStyle: {
                  "margin-bottom": "0.24rem",
                  "font-weight": "bold",
                },
              },
              [
                _vm._v(
                  " 提示：您完成下方相应任务即可获得奖励金！ 奖励金将直接进入您的机构余额，"
                ),
                _c("span", [_vm._v("奖励金可用于支付您的VIP会员费")]),
                _vm._v(
                  " 、购买销售活动中需要的 平台红包等，但奖励金不可直接提现。 "
                ),
              ]
            ),
            _c("div", { staticClass: "main" }, [
              _c(
                "div",
                [
                  _vm._l(5, function (item) {
                    return _c(
                      "div",
                      { key: item, staticClass: "mainLine" },
                      [
                        _c("p", { staticClass: "p2" }, [
                          _vm._v("每成功生成 "),
                          _c("span", [_vm._v("20")]),
                          _vm._v(" 库存"),
                        ]),
                        _c("p", { staticClass: "p3" }, [_vm._v("即可获得")]),
                        _c("p", [
                          _c("span", { staticClass: "span1" }, [_vm._v("100")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "span2" }, [
                            _vm._v("积分"),
                          ]),
                        ]),
                        _c("p", { staticClass: "p4" }, [_vm._v("+")]),
                        _c("p", { staticClass: "p5" }, [
                          _c("span", { staticClass: "span1" }, [_vm._v("200")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("奖励金")]),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticClass: "btns",
                            attrs: { size: "small", type: "primary" },
                          },
                          [_vm._v("马上去添加库存 ")]
                        ),
                      ],
                      1
                    )
                  }),
                  _c("p", { staticClass: "p6" }, [_vm._v("说明：XXXXXXXXX")]),
                ],
                2
              ),
            ]),
          ]),
          _c(
            "el-button",
            {
              staticClass: "btns",
              attrs: { slot: "footer", size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
              slot: "footer",
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }